import { IonRouterLink } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { PlanFeatureDetails } from '../plan/plan.types';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

export interface PaywallViewMoreProps extends PaywallComponentBaseProps {}

const PaywallViewMore = (props: PaywallViewMoreProps) => {
  const { planEntitlementKey, isFeatureAvailable, children } = props;
  const { i18n } = useTranslation();

  const details = PlanFeatureDetails[planEntitlementKey];
  const featureName: string = details?.titleKey
    ? i18n.t(details.titleKey)
    : i18n.t('common:unknown');

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;

        return (
          <>
            {isAvailable ? (
              children
            ) : (
              <IonRouterLink
                onClick={() => {
                  presentUpgrade();
                }}
              >
                {i18n.t('common:want_to_see_more', {
                  featureName: featureName?.toLowerCase(),
                })}
              </IonRouterLink>
            )}
          </>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallViewMore };
